import React, { forwardRef } from 'react'
import { Menu } from '@headlessui/react'
import cx from 'classnames'

import { PlainModal } from 'components/feedback'
import type { DropdownProps } from '../../Dropdown'

// Stub for PlainModal closeModal prop (unchanged)
const closeModalStub = () => null

type DropdownModalProps = {
  contentClassName?: string
  content:
    | React.ReactElement
    | ((params: { close: () => void }) => React.ReactElement)
  close: () => void // close function from Menu
}

const DropdownModal: React.FC<DropdownModalProps> = props => {
  const { content, contentClassName, close } = props

  return (
    <PlainModal
      withCloseButton={false}
      closeModal={closeModalStub} // Could use `close` here if PlainModal supports it
      containerClassName="z-sup-modal"
      contentClassName={contentClassName}
    >
      <Menu.Items>
        {typeof content === 'function' ? content({ close }) : content}
      </Menu.Items>
    </PlainModal>
  )
}

const Mobile = forwardRef<HTMLDivElement, DropdownProps>((props, ref) => {
  const { children, className, buttonClassName, content, contentClassName } =
    props

  return (
    <Menu ref={ref} as="div">
      {({ open, close }) => (
        <>
          <Menu.Button
            className={cx(className, buttonClassName)}
            disabled={!content}
          >
            {typeof children === 'function' ? (
              children({ isOpened: open, close })
            ) : (
              <div className="inline-flex items-center">{children}</div>
            )}
          </Menu.Button>
          {open && (
            <DropdownModal
              content={content} // content receives close if it’s a function
              contentClassName={contentClassName}
              close={close} // Pass close to DropdownModal
            />
          )}
        </>
      )}
    </Menu>
  )
})

export default Mobile
